import { render, staticRenderFns } from "./FormSectionContent.vue?vue&type=template&id=48872f1a&"
import script from "./FormSectionContent.vue?vue&type=script&lang=ts&"
export * from "./FormSectionContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports